import { cn } from '../lib/cn';
import { initials } from '../lib/format';

export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full border border-white/10 bg-gradient-to-br from-violet-500/30 to-cyan-500/20 font-semibold text-violet-100',
        {
          'size-8 text-[11px]': size === 'sm',
          'size-10 text-[13px]': size === 'md',
          'size-16 text-xl': size === 'lg',
        },
        className,
      )}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
